import { render, staticRenderFns } from "./Fullscreen.vue?vue&type=template&id=5d13352f&scoped=true&"
import script from "./Fullscreen.vue?vue&type=script&lang=js&"
export * from "./Fullscreen.vue?vue&type=script&lang=js&"
import style0 from "./Fullscreen.vue?vue&type=style&index=0&id=5d13352f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d13352f",
  null
  
)

export default component.exports